<script>
import { sharedData } from '../../../static/js/vue_specific/sharedData';
import {
  isDotNetDate,
  convertDotNetDateToJSDate,
  weekdayDateMonth,
} from '../../../static/js/dateHelpers';
import axios from 'axios';

export default {
  props: ['url', 'request', 'componentTexts'],
  data() {
    return {
      initRequest: {},
      currentRequest: {},
      events: [],
      currentPageIndex: 0,
      nextPageIndex: 0,
      currentCitys: [],
      currentDates: [],
      currentCity: 'allCities',
      currentDate: 'allDates',
      loading: false,
      langId: '',
      PromotedEvent: null,
      shared: sharedData,
    };
  },
  async created() {
    await import(
      /* webpackChunkName: "forms" */ '../../../static/js/loaders/forms.js'
    );
    this.initRequest = this.request;
    if (this.initRequest.LanguageId) {
      this.langId = this.initRequest.LanguageId;
    }
    this.currentRequest = this.request;
    this.loading = true;
    let req = this.request;

    if (req.DefaultCity || req.City) {
      this.currentCity = req.DefaultCity ? req.DefaultCity : req.City;
    }

    if (req.Month) {
      this.currentDate = req.Month;
    }
    let response = await axios.post(this.url, this.request);
    // console.log({ response: response });
    let data = response.data;

    if (data.PromotedEvent) {
      let dateRaw = data.PromotedEvent.StartDate;

      if (isDotNetDate(data.PromotedEvent.StartDate)) {
        dateRaw = convertDotNetDateToJSDate(data.PromotedEvent.StartDate);
      }

      data.PromotedEvent.date = dateRaw;
      data.PromotedEvent.StartDate = weekdayDateMonth(dateRaw, this.langId);

      this.PromotedEvent = data.PromotedEvent;
    }

    if (data.Events && data.Events.length > 0) {
      data.Events.map((event) => {
        //Hitta startdatumet och konvertera till ett läsbart datum beroende på LanguageID.
        if (event && event.StartDate) {
          // New
          let dateRaw = event.StartDate;
          if (isDotNetDate(event.StartDate)) {
            dateRaw = convertDotNetDateToJSDate(event.StartDate);
          }

          event.date = dateRaw;
          let isMultipleDays = this.checkEventDates(event);
          event.isMultipleDays = isMultipleDays;

          if (isMultipleDays) {
            event.captionDate = this.createCaptionDate(event);
            event.datesAndYear = this.createDatesWithYear(event);
          }
          event.StartDate = weekdayDateMonth(dateRaw, this.langId);
        }
      });
      this.events = data.Events;
      // console.log({ createdEvents: data.Events });
    }
    if (data.CurrentPageIndex) {
      this.currentPageIndex = data.CurrentPageIndex;
    }
    if (data.NextPageIndex) {
      this.nextPageIndex = data.NextPageIndex;
    }
    if (data.AvailableCitys) {
      this.currentCitys = data.AvailableCitys;
    }
    if (data.AvailableDates) {
      this.currentDates = data.AvailableDates;
    }

    this.loading = false;
  },
  methods: {
    async fetchData(increasePageIndex) {
      try {
        this.loading = true;
        this.currentPageIndex = 0;
        this.nextPageIndex = 0;
        this.currentRequest.PageIndex = 0;
        if (increasePageIndex) {
          this.currentRequest.PageIndex = increasePageIndex;
        }
        const response = await axios.post(this.url, this.currentRequest);
        const data = response.data;

        if (data.Events && data.Events.length > 0) {
          data.Events.map((event) => {
            //Hitta startdatumet och konvertera till ett läsbart datum beroende på LanguageID.
            if (event && event.StartDate) {
              let dateRaw = event.StartDate;
              if (isDotNetDate(event.StartDate)) {
                dateRaw = convertDotNetDateToJSDate(event.StartDate);
              }

              event.date = dateRaw;
              let isMultipleDays = this.checkEventDates(event);
              event.isMultipleDays = isMultipleDays;

              if (isMultipleDays) {
                event.captionDate = this.createCaptionDate(event);
                event.datesAndYear = this.createDatesWithYear(event);
              }
              event.StartDate = weekdayDateMonth(dateRaw, this.langId);
            }
          });
          if (!increasePageIndex) {
            this.events = data.Events;
          } else {
            data.Events.map((event) => {
              this.events.push(event);
            });
          }
        }
        if (data.CurrentPageIndex) {
          this.currentPageIndex = data.CurrentPageIndex;
        }
        if (data.NextPageIndex) {
          this.nextPageIndex = data.NextPageIndex;
        }
        if (data.AvailableCitys) {
          this.currentCitys = data.AvailableCitys;
        }
        if (data.AvailableDates) {
          this.currentDates = data.AvailableDates;
        }
        this.loading = false;
      } catch (error) {
        // console.log(error);
        this.loading = false;
      }
    },
    async onChangeCity(event) {
      // console.log(event.target.value);
      if (event.target.value !== 'allCities') {
        this.currentRequest.City = event.target.value;
        this.currentRequest.DefaultCity = event.target.value;
        this.fetchData();
      } else {
        this.currentRequest.City = '';
        this.currentRequest.DefaultCity = '';
        this.fetchData();
      }
    },
    async fetchMoreData(nextPageNumber) {
      if (nextPageNumber) {
        this.currentRequest.PageIndex = nextPageNumber;
        this.fetchData(nextPageNumber);
      }
    },
    async onChangeDate(event) {
      // console.log(event.target.value);
      if (event.target.value !== 'allDates') {
        this.currentRequest.Month = event.target.value;
        this.fetchData();
      } else {
        this.currentRequest.Month = '';
        this.fetchData();
      }
    },
    capitalize(value) {
      if (!value) return '';

      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    checkEventDates(event) {
      let startDate = new Date(event.date);
      let stopDate = new Date(event.StopDate);

      startDate.setHours(0, 0, 0, 0);
      stopDate.setHours(0, 0, 0, 0);
      if (stopDate.getTime() > startDate.getTime()) {
        return true;
      } else {
        return false;
      }
    },
    createCaptionDate(event) {
      let startDate = new Date(event.date);
      let endDate = new Date(event.StopDate);

      let start = startDate.toLocaleDateString('sv-SE', {
        day: 'numeric',
        month: 'long',
      });
      let stop = endDate.toLocaleDateString('sv-SE', {
        day: 'numeric',
        month: 'long',
      });
      return `${start} - ${stop}`;
    },
    createDatesWithYear(event) {
      let startDate = new Date(event.date);
      let endDate = new Date(event.StopDate);

      let start = startDate.toLocaleDateString('sv-SE', {
        day: 'numeric',
        month: 'long',
      });
      let stop = endDate.toLocaleDateString('sv-SE', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
      return `${start} - ${stop}`;
    },
  },
  computed: {
    eventsFilteredByDate() {
      if (!this.events || this.events?.length === 0) {
        return [];
      }

      return this.events.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
    },
  },
};
</script>

<template>
  <div class="vld-parent container events--component enable-forms">
    <div class="row">
      <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
        <vloading
          :height="32"
          :can-cancel="false"
          :width="32"
          :color="'#404040'"
          :is-full-page="false"
          :active.sync="loading"></vloading>
      </div>
    </div>
    <div class="row mb-md">
      <div class="col-md-10 mt-xs offset-md-1 col-lg-8 offset-lg-2">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="d-flex flex-column">
              <label
                class="font-weight-bold"
                for="citySelect"
                v-html="componentTexts.placeText.value"></label>
              <select
                class="select-css"
                id="citySelect"
                v-if="currentCitys"
                v-model="currentCity"
                @change="onChangeCity($event)">
                <option value="allCities" selected>
                  {{ componentTexts.placeSelectAllText.value }}
                </option>
                <option
                  v-for="(city, index) in currentCitys"
                  :value="city"
                  :key="index">
                  {{ city }}
                </option>
              </select>
              <div class="d-block d-sm-none mb-3"></div>
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="d-flex flex-column">
              <label
                class="font-weight-bold"
                for="dateSelect"
                v-html="componentTexts.timeText.value"></label>
              <select
                class="select-css"
                id="dateSelect"
                v-if="currentDates"
                v-model="currentDate"
                @change="onChangeDate($event)">
                <option value="allDates" selected>
                  {{ componentTexts.timeSelectAllText.value }}
                </option>
                <option
                  v-for="(date, index) in currentDates"
                  :value="date.key"
                  :key="index">
                  {{ date.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="PromotedEvent" class="row event--container">
      <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
        <article role="article" class="d-flex flex-column event">
          <div class="d-flex flex-row">
            <div class="d-flex flex-fill align-items-center">
              <time
                class="caption"
                v-if="PromotedEvent && PromotedEvent.StartDate"
                >{{ capitalize(PromotedEvent.StartDate) }}</time
              >
            </div>
            <div class="d-flex flex-fill"></div>
            <div class="d-flex flex-fill"></div>
          </div>
          <a v-if="PromotedEvent.Url" :href="PromotedEvent.Url">
            <h2
              class="heading-level-3"
              v-if="PromotedEvent.Title"
              v-html="PromotedEvent.Title"></h2>
          </a>

          <p v-if="PromotedEvent.Intro" v-html="PromotedEvent.Intro"></p>
          <div
            class="d-flex flex-row align-items-center flex-wrap PromotedEvent--info">
            <time
              class="mr-3"
              v-if="PromotedEvent && PromotedEvent.StartDate"
              >{{ capitalize(PromotedEvent.StartDate) }}</time
            >
            <div
              class="d-flex flex-row align-items-center mr-3"
              v-if="
                PromotedEvent &&
                PromotedEvent.StartTime &&
                PromotedEvent.StopTime
              ">
              <time>{{ PromotedEvent.StartTime }}</time
              >&nbsp;-&nbsp;
              <time>{{ PromotedEvent.StopTime }}</time>
            </div>
            <p
              class="mb-0"
              v-if="PromotedEvent.City"
              v-html="PromotedEvent.City" />
            <p class="mb-0" v-if="PromotedEvent.City && PromotedEvent.Location">
              ,&nbsp;
            </p>
            <p
              class="mb-0"
              v-if="PromotedEvent.Location"
              v-html="PromotedEvent.Location"></p>
          </div>
        </article>
      </div>
    </div>

    <div
      v-if="events"
      class="row event--container"
      v-for="(event, index) in eventsFilteredByDate"
      :key="index">
      <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2" v-if="event">
        <article role="article" class="d-flex flex-column event">
          <div class="d-flex flex-row">
            <div class="d-flex flex-fill align-items-center">
              <time
                class="caption"
                v-if="event && event.StartDate && !event.isMultipleDays"
                >{{ capitalize(event.StartDate) }}</time
              >
              <time v-else-if="event.isMultipleDays" class="caption">
                {{ event.captionDate }}
              </time>
            </div>
            <div class="d-flex flex-fill"></div>
            <div class="d-flex flex-fill"></div>
          </div>
          <a v-if="event.Url" :href="event.Url">
            <h2
              class="heading-level-3"
              v-if="event.Title"
              v-html="event.Title"></h2>
          </a>

          <p v-if="event.Intro" v-html="event.Intro"></p>
          <div class="d-flex flex-row align-items-center flex-wrap event--info">
            <time
              class="mr-3"
              v-if="event.StartDate && !event.isMultipleDays"
              >{{ capitalize(event.StartDate) }}</time
            >
            <time v-else-if="event.isMultipleDays" class="mr-3">
              {{ event.datesAndYear }}
            </time>
            <div
              class="d-flex flex-row align-items-center mr-3"
              v-if="event.StartTime && event.StopTime && !event.isMultipleDays">
              <time>{{ event.StartTime }}</time
              >–
              <time>{{ event.StopTime }}</time>
            </div>
            <p class="mb-0" v-if="event.City" v-html="event.City" />
            <p class="mb-0" v-if="event.City && event.Location">,&nbsp;</p>
            <p class="mb-0" v-if="event.Location" v-html="event.Location"></p>
          </div>
        </article>
      </div>
    </div>

    <div class="row mt-md mb-md">
      <div class="col-12">
        <div class="d-flex justify-content-center align-items-center">
          <button
            class="button-small"
            v-if="nextPageIndex > currentPageIndex"
            @click="fetchMoreData(nextPageIndex)">
            {{ componentTexts.showMoreText.value }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
